import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/BasicLayout';
/**
 * 众筹商城
 */

var crowdfundingMall = {
  path: '/crowdfundingMall',
  component: BasicLayout,
  redirect: '/crowdfundingMall',
  children: [{
    path: '/crowdfundingMall',
    name: 'CrowdfundingMall',
    component: function component() {
      return import('views/crowdfundingMall/Index');
    },
    meta: {
      title: '商城',
      keepAlive: true
    }
  }, {
    path: '/crowdfundingMall/detail',
    name: 'CrowdfundingDetail',
    component: function component() {
      return import('views/crowdfundingMall/Detail');
    },
    meta: {
      title: '商品详情页'
    }
  }, {
    path: '/crowdfundingMall/record',
    name: 'CrowdfundingRecord',
    component: function component() {
      return import('views/crowdfundingMall/Record');
    },
    meta: {
      title: '成交记录'
    }
  }, {
    path: '/crowdfundingMall/copyrighted',
    name: 'Copyrighted',
    component: function component() {
      return import('@/views/copyrightCollect/Products');
    },
    meta: {
      title: '相关版权品'
    }
  }, {
    path: '/crowdfundingMall/payOrder',
    name: 'CrowdfundingPayOrder',
    component: function component() {
      return import('views/crowdfundingMall/PayOrder');
    },
    meta: {
      title: '确认订单'
    }
  }, {
    path: '/crowdfundingMall/mallCenter',
    name: 'MallCenter',
    component: function component() {
      return import('views/crowdfundingMall/mallCenter/Index');
    },
    meta: {
      title: '商城中心',
      keepAlive: true
    }
  }, {
    path: '/crowdfundingMall/mallCenter/orderDetail',
    name: 'OrderDetail',
    component: function component() {
      return import('@/views/crowdfundingMall/mallCenter/orderDetail');
    },
    meta: {
      title: '订单详情'
    }
  }, // {
  //   path: '/crowdfundingMall/payResult',
  //   name: 'PayResult',
  //   component: () => import('@/views/crowdfundingMall/PayResult')
  // },
  {
    path: '/crowdfundingMall/addressManage',
    name: 'AddressManage',
    component: function component() {
      return import('@/views/crowdfundingMall/mallCenter/addressManage');
    },
    meta: {
      title: '地址管理'
    }
  }, {
    path: '/crowdfundingMall/addressInfo',
    name: 'AddressInfo',
    component: function component() {
      return import('@/views/crowdfundingMall/mallCenter/addressInfo');
    },
    meta: {
      title: '地址信息'
    }
  }]
};
export default crowdfundingMall;